import React from "react";
import Layout from "./Layout";
import RankingSection from "../sections/RankingSection";

const Ranking = () => {
  return (
    <Layout>
      <RankingSection />
    </Layout>
  );
};

export default Ranking;
